import {
  React,
  Component,
  PropTypes
} from 'imports/CommonImports';

import {RaisedButton} from 'material-ui';

const styles = {
  button: {
    width: '15em',
  },
}

class CancelButton extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    return(
      <RaisedButton
        disabled={this.props.disabled}
        labelColor='#FFFFFF'
        backgroundColor='#BA0F0F'
        label={this.props.label}
        onClick={this.props.onClick}
        style={this.props.style || styles.button}
        href={this.props.href}
        labelPosition={this.props.labelPosition}
        icon={this.props.icon}
        />
    )
  }
}

CancelButton.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string
}

export default CancelButton;



// WEBPACK FOOTER //
// ./src/components/design/CancelButton.js